import { LoadingScreen } from "components/LoadingScreen";
import { useProcessoFinanceiroAprovar } from "../../hooks/useProcessoFinanceiroAprovar";
import { FiltroCriarLote } from "./FiltrosCriarLote";
import { ListaProcessosVincularLote } from "./ListaProcessosVincularLote";
import { ModalAdicionarCusto } from "./ModalAdicionarCusto";
import { ICriarLote } from "../../interface/ICriarLote";
import { useEffect, useState } from "react";
import { IProcessoCriarLote } from "../../interface/IProcessosCriarLote";
import { IAdicionarCusto } from "../../interface/IAdicionarCusto";
import { FormCriarLote } from "./FormCriarLote";
import { ListaResumoProcessosCriarLote } from "./ListaResumoProcessosCriarLote";
import { useProcessoFinanceiroDescricao } from "hooks/useProcessoFinanceiroDescricao";
import { ModalCertezaCancelarLote } from "./ModalCertezaCancelarLote";
import { ModalSucessoAdicionarCusto } from "./ModalSucessoAdicionarCusto";
import { ModalSucessoCriarLote } from "./ModalSucessoCriarLote";
import { toastErro } from "components/Toast";

interface IProps {
  dadosCriarLote: ICriarLote;
}

export function CriarLote({ dadosCriarLote }: IProps) {
  const [tela, setTela] = useState<"vincular" | "resumo">("vincular");
  const [processos, setProcessos] = useState<IProcessoCriarLote[]>([]);
  const [showModalDetalhesServico, setShowModalDetalhesServico] =
    useState<boolean>(false);
  const [showModalCertezaCancelarLote, setShowModalCertezaCancelarLote] =
    useState<boolean>(false);
  const [showModalSucessoAddCusto, setShowModalSucessoAddCusto] =
    useState<boolean>(false);
  const [showModalSucessoSalvarLote, setShowModalSucessoSalvarLote] =
    useState<boolean>(false);
  const [idLoteCriado, setIdLoteCriado] = useState<number>(0);

  const {
    setSelectedRows,
    clearRows,
    listarProcessosVincularLote,
    processosVincularLote,
    selectedRows,
    loading,
    setProcessosVincularLote,
    salvarLote,
    validarDuplicidade,
  } = useProcessoFinanceiroAprovar();
  const { processosFinanceirosDescricoesOptions, listarOptions } =
    useProcessoFinanceiroDescricao();

  const onClickAddCusto = () => {
    setShowModalDetalhesServico(true);
  };
  const onCloseModalAddCusto = () => {
    setShowModalDetalhesServico(false);
  };

  useEffect(() => {
    setProcessosVincularLote([]);
  }, [tela]);

  const onSubmitAddCusto = (dados: IAdicionarCusto) => {
    onCloseModalAddCusto();
    setTela("resumo");
    setProcessos((processosAtuais) => [
      ...processosAtuais.map((processo) => {
        const estaSelecionado = selectedRows.some(
          (row) => row.idProcesso === processo.idProcesso
        );

        if (!estaSelecionado) {
          return processo;
        }

        const indice = processo.custos.findIndex(
          (custo) => custo.idDescricao === dados.servico
        );

        let novosCustos;

        if (indice !== -1) {
          novosCustos = processo.custos.map((custo, i) =>
            i === indice ? { ...custo, valor: dados.valor } : custo
          );
        } else {
          novosCustos = [
            ...processo.custos,
            {
              idDescricao: dados.servico,
              valor: dados.valor,
              label:
                processosFinanceirosDescricoesOptions.find(
                  (pfd) => pfd.value === dados.servico
                )?.label ?? "-",
            },
          ];
        }

        return {
          ...processo,
          custos: novosCustos,
        };
      }),

      ...selectedRows
        .filter(
          (row) =>
            !processosAtuais.some(
              (processo) => processo.idProcesso === row.idProcesso
            )
        )
        .map((row) => {
          const dadosProcesso = processosVincularLote.find(
            (processo) => processo.idProcesso === row.idProcesso
          );
          return {
            idProcesso: row.idProcesso,
            placa: dadosProcesso?.placa ? dadosProcesso?.placa : null,
            chassi: dadosProcesso?.chassi ? dadosProcesso?.chassi : null,
            nomeEmpresa: dadosProcesso?.nomeEmpresa
              ? dadosProcesso?.nomeEmpresa
              : null,
            nomeDivisao: dadosProcesso?.nomeDivisao
              ? dadosProcesso?.nomeDivisao
              : null,
            servico: dadosProcesso?.servico ? dadosProcesso?.servico : null,
            custos: [
              {
                idDescricao: dados.servico,
                valor: dados.valor,
                label:
                  processosFinanceirosDescricoesOptions.find(
                    (pfd) => pfd.value === dados.servico
                  )?.label ?? "-",
              },
            ],
          };
        }),
    ]);

    setShowModalSucessoAddCusto(true);
  };

  const onSubmitSalvarLote = async () => {
    const { hasErro: temErro, data: listaLancamentos } =
      await validarDuplicidade(dadosCriarLote, processos);

    if (
      temErro ||
      !Array.isArray(listaLancamentos) ||
      !listaLancamentos.length
    ) {
      toastErro("Erro ao verificar duplicidade do lançamento");
      return;
    }

    const { hasErro, data } = await salvarLote(
      dadosCriarLote,
      listaLancamentos
    );

    if (hasErro || !Array.isArray(data) || !data.length) {
      toastErro("Erro ao criar lote");
      return;
    }

    setIdLoteCriado(data[0].id_lote);
    setShowModalSucessoSalvarLote(true);
  };

  return (
    <>
      <LoadingScreen mostrar={loading} />
      {tela === "vincular" ? (
        <div>
          <FiltroCriarLote
            onSubmit={listarProcessosVincularLote}
            habilitarCancelar={!!processos.length}
            onClickCancelar={() => {
              setTela("resumo");
            }}
          />
          <ListaProcessosVincularLote
            clearRows={clearRows}
            setRowsSelected={setSelectedRows}
            dados={processosVincularLote}
            selectedRows={selectedRows}
            onClickAddCusto={onClickAddCusto}
            tela={tela}
          />
        </div>
      ) : (
        <div>
          <FormCriarLote
            dadosCriarLote={dadosCriarLote}
            onClickCancelar={() => {
              setShowModalCertezaCancelarLote(true);
            }}
            setTela={setTela}
            onClickSalvar={onSubmitSalvarLote}
          />
          <ListaResumoProcessosCriarLote
            clearRows={clearRows}
            setRowsSelected={setSelectedRows}
            processos={processos}
            selectedRows={selectedRows}
            setProcessos={setProcessos}
            tela={tela}
          />
        </div>
      )}

      <ModalAdicionarCusto
        show={showModalDetalhesServico}
        handleClose={onCloseModalAddCusto}
        onSubmit={onSubmitAddCusto}
        idFornecedor={dadosCriarLote.fornecedor}
        listarOptions={listarOptions}
        processosFinanceirosDescricoesOptions={
          processosFinanceirosDescricoesOptions
        }
      />
      <ModalCertezaCancelarLote
        onConfirm={() => window.location.reload()}
        show={showModalCertezaCancelarLote}
        handleClose={() => {
          setShowModalCertezaCancelarLote(false);
        }}
      />
      <ModalSucessoAdicionarCusto
        show={showModalSucessoAddCusto}
        handleClose={() => setShowModalSucessoAddCusto(false)}
      />
      <ModalSucessoCriarLote
        show={showModalSucessoSalvarLote}
        idLote={idLoteCriado}
      />
    </>
  );
}
